
import L from "plugins/leaflet/index"
import Promise from "plugins/bluebird/index"
import log from "plugins/loglevel/index"

let layer = null as null | L.Layer
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
let promise_resolve = (_layer: L.Layer) => {}
/* eslint-enable @typescript-eslint/no-empty-function */
/* eslint-enable no-empty-function */
const promise: Promise<L.Layer | L.Google> = new Promise((resolve) => {
  promise_resolve = resolve
})

const TYPES = {
  GOOGLE_MAPS_API_WRAPPER:        "GOOGLE_MAPS_API_WRAPPER",
  IMAGE_LOADER_WITH_URL_TEMPLATE: "IMAGE_LOADER_WITH_URL_TEMPLATE",
  UNKNOWN:                        "UNKNOWN",
}

const GoogleMapsTileLayer = {
  TYPES,
  setLayer(new_layer: null | L.Layer){
    if (new_layer == null){
      log.warn("new_layer is null/undefined!")
      return
    }

    layer = new_layer
    promise_resolve(new_layer)
  },
  getLayerPromise: () => promise,
  getLayer: () => layer,
  getLayerType(){
    if (layer === null){
      return null
    }

    if (layer instanceof L.Google){
      return TYPES.GOOGLE_MAPS_API_WRAPPER
    }

    if (layer instanceof L.TileLayer){
      return TYPES.IMAGE_LOADER_WITH_URL_TEMPLATE
    }

    return TYPES.UNKNOWN
  },
}

export default GoogleMapsTileLayer
